<template>
  <button
    :type="buttonType"
    :class="[
      `${prefix}btn`,
      `${prefix}btn--${theme}`,
      { ...getBtnClass }
    ]"
    :disabled="disabled"
    v-on="$listeners"
  >
    <mpx-icon
      v-if="isIconLeft"
      size="small"
      :class="[
        `${prefix}inline-block`,
        `${prefix}mr-2`,
      ]"
      :variant="iconVariant"
    />
    <mpx-icon
      v-if="isLoading || isIconOnly"
      :variant="getIconOnlyVariant"
      size="small"
      :class="[
        `${prefix}inline-block`,
        { ...getRotatingClass }
      ]"
    />
    <slot>
      <div
        ref="btnLabel"
        :class="[
          `${prefix}inline-block`,
          `${prefix}btn__label`,
        ]">
        {{ convertedLabel }}
      </div>
    </slot>
    <mpx-icon
      v-if="isIconRight"
      size="small"
      :class="[
        `${prefix}inline-block`,
        `${prefix}ml-2`,
      ]"
      variant="caret-down"
    />
  </button>
</template>

<script>
import MpxIcon from '../Icon';

export default {
  name: 'MpxButton',
  components: { MpxIcon },
  props: {
    prefix: {
      type: String,
      default: 'mpx-',
    },
    variant: {
      type: String,
      default: 'default',
    },
    theme: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    iconVariant: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    convertedLabel() {
      return this.label ? this.label[0].toUpperCase() + this.label.slice(1) : null;
    },
    isIconLeft() {
      return this.variant === 'icon-left';
    },
    isIconRight() {
      return this.variant === 'icon-right';
    },
    isIconOnly() {
      return this.variant === 'icon-only';
    },
    isLoading () {
      return this.variant === 'loading';
    },
    getRotatingClass() {
      const output = {};
      output[`${this.prefix}rotating`] = this.isLoading;
      return output;
    },
    getIconOnlyVariant() {
      return this.isLoading ? 'loader' : this.iconVariant;
    },
    getBtnClass() {
      const output = {};
      output[`${this.prefix}btn--small`] = this.size === 'small';
      output[`${this.prefix}btn__icon--left`] = this.isIconLeft;
      output[`${this.prefix}btn__icon--right`] = this.isIconRight;
      output[`${this.prefix}btn__icon--only`] = this.isIconOnly;
      return output;
    },
  },
};
</script>
